import React from "react";
import Dropdown from "../../../DropDowns/DropDown";
import {
  ACCESS_LEVELS,
  AccessLevel,
  HTTP_METHODS,
  MethodAccessGridValue,
  defaultMethodAccess,
} from "./permissionObjectUtils";

// What the service applies when no level is stored for a method.
const DEFAULT_LEVEL = defaultMethodAccess("API");

interface MethodAccessGridProps {
  value: MethodAccessGridValue;
  onChange: (v: MethodAccessGridValue) => void;
  readOnly: boolean;
}

/** One row per method (Method | Level), so "default (admin)" always fits. */
const MethodAccessGrid: React.FC<MethodAccessGridProps> = ({ value, onChange, readOnly }) => (
  <div>
    <div className="max-w-md border border-gray-200 rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="text-left font-semibold px-4 py-2 w-28">Method</th>
            <th className="text-left font-semibold px-4 py-2">Level</th>
          </tr>
        </thead>
        <tbody>
          {HTTP_METHODS.map((method) => (
            <tr key={method} className="border-t border-gray-200">
              <td className="px-4 py-2 font-medium text-gray-700">{method}</td>
              <td className="px-4 py-1.5">
                <Dropdown
                  ariaLabel={`${method} access`}
                  options={[
                    { value: "", label: `default (${DEFAULT_LEVEL[method]})` },
                    ...ACCESS_LEVELS.map((level) => ({ value: level, label: level })),
                  ]}
                  selectedValue={value[method]}
                  disabled={readOnly}
                  onValueChange={(v) => onChange({ ...value, [method]: v as AccessLevel | "" })}
                  placeholder={`default (${DEFAULT_LEVEL[method]})`}
                  className={`w-full border rounded-lg text-sm ${
                    readOnly ? "bg-[#f9f9f9] border-gray-300" : "border-blue-500"
                  }`}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="text-xs text-gray-500 mt-2">A POST that only reads data should be read.</p>
  </div>
);

export default MethodAccessGrid;
